<template>
  <div id="Urzadzenia">
    <h4>{{$t('message.devices')}}</h4>

    <div>
      <div id="nav">
        <button :class="{ 'active' : (page==='main')}" id="tab-home" md-label="Główne" @click="changePage('main')">{{$t('message.glowne')}}</button>
        <button :class="{ 'active' : (page==='other')}" id="tab-pages" md-label="Pozostałe" @click="changePage('other')">{{$t('message.pozostale')}}</button>
      </div>

      <div class="tab-content">
        <div id="tab-main" class="" v-if="page === 'main'">
          <form>
            <div class="form-group">
              <label for="wzmacniacz">{{$t('message.wzmacniacz')}}</label>
              <input
              type="number" class="form-control form-control-sm" id="wzmacniacz"
              :min="inputs.wzmacniacz.min"
              :max="inputs.wzmacniacz.max"
              v-model="inputData.wzmacniacz.value"
              @change="changeInputs('wzmacniacz')">
            </div>

            <div class="form-group">
              <label for="wzmacniacz_rezerwowy">{{$t('message.wzmacniacz_rez')}}</label>
              <input type="number" class="form-control form-control-sm" id="wzmacniacz_rezerwowy"
              :min="inputs.wzmacniacz_rezerwowy.min"
              :max="inputs.wzmacniacz_rezerwowy.max"
              v-model="inputData.wzmacniacz_rezerwowy.value"
              @change="changeInputs('wzmacniacz_rezerwowy')">
            </div>

            <div class="form-group">
              <label for="kontroler">{{$t('message.kontroler')}}</label>
              <input type="number" class="form-control form-control-sm" id="kontroler"
              :min="inputs.kontroler.min"
              :max="inputs.kontroler.max"
              v-model="inputData.kontroler.value"
              @change="changeInputs('kontroler')">
            </div>

            <div class="form-group">
              <label for="router">{{$t('message.router')}}</label>
              <input type="number" class="form-control form-control-sm" id="router"
              :min="inputs.router.min"
              :max="inputs.router.max"
              v-model="inputData.router.value"
              @change="changeInputs('router')">
            </div>
          </form>
        </div>
        <div id="tab-other" class="" v-if="page === 'other'">
          <form>
            <div class="form-group">
              <label for="obudowa_plytki" style="line-height: 11px;">{{$t('message.plytki_konca')}}</label>
              <input type="number" class="form-control form-control-sm"  id="obudowa_plytki"
              :min="inputs.obudowa_plytki.min"
              :max="inputs.obudowa_plytki.max"
              v-model="inputData.obudowa_plytki.value"
              @change="changeInputs('obudowa_plytki')">
            </div>
            <div class="form-group">
              <label for="panel_wentylacyjny">{{$t('message.panel_wentyl')}}</label>
              <input type="number" class="form-control form-control-sm" id="panel_wentylacyjny"
              :disabled = !check_wentylator
              :min="inputs.panel_wentylacyjny.min"
              :max="inputs.panel_wentylacyjny.max"
              v-model="inputData.panel_wentylacyjny.value"
              @change="changeInputs('panel_wentylacyjny')">
            </div>
            <div class="form-group">
              <label for="kolka">{{$t('message.zestaw_kolek')}}</label>
              <input type="number" class="form-control form-control-sm" id="kolka"
              :min='inputs.kolka.min'
              :max='inputs.kolka.max'
              v-model="inputData.kolka.value"
              @change="changeInputs('kolka')">
            </div>
          </form>
        </div>

        <p style="margin: 10px 0px 6px;text-align: left;">{{$t('message.mikrofon')}}</p>
        <form>
          <div class="form-group">
            <md-avatar>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill iconInfo" viewBox="0 0 16 16" style="">
              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
              <md-tooltip md-direction="right" class="tooltipImg">
                <h4>{{$t('message.wariant1_title')}}</h4>
                <img src="../assets/wariant1.jpg"/>
                <p>{{$t('message.wariant1')}}</p>
              </md-tooltip>
            </md-avatar>
            <label for="wariant1" class="wariant-label">{{$t('message.wariant')}} 1</label>
            <input type="number" class="form-control form-control-sm wariant-input" id="wariant1"
            :min="inputs.wariant1.min"
            :max="inputs.wariant1.max"
            v-model="inputData.wariant1.value"
            @change="changeInputs('wariant1')">
            <span v-if="inputs.wariant1.value>0" class="wariant-span">{{$t('message.rozszerzenie')}}</span>
            <input
            v-if="inputs.wariant1.value>0"
            type="number" class="form-control form-control-sm wariant-rozszerzenia-input" id="wariant1_rozszerzenia"
            :min="inputs.wariant1_rozszerzenia.min"
            :max="inputs.wariant1_rozszerzenia.max"
            v-model="inputData.wariant1_rozszerzenia.value"
            @change="changeInputs('wariant1_rozszerzenia')">
          </div>

          <div class="form-group">
            <md-avatar>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill iconInfo" viewBox="0 0 16 16" style="">
              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
              <md-tooltip md-direction="right" class="tooltipImg">
                <h4>{{$t('message.wariant2_title')}}</h4>
                <img src="../assets/wariant2.jpg"/>
                <p>{{$t('message.wariant2')}}</p>
              </md-tooltip>
            </md-avatar>
            <label for="wariant2" class="wariant-label">{{$t('message.wariant')}} 2</label>
            <input type="number" class="form-control form-control-sm wariant-input" id="wariant2"
            :min="inputs.wariant2.min"
            :max="inputs.wariant2.max"
            v-model="inputData.wariant2.value"
            @change="changeInputs('wariant2')">
            <span v-if="inputs.wariant2.value>0" class="wariant-span">{{$t('message.rozszerzenie')}}</span>
            <input v-if="inputs.wariant2.value>0"
            type="number" class="form-control form-control-sm wariant-rozszerzenia-input" id="wariant2_rozszerzenia"
            :min="inputs.wariant2_rozszerzenia.min"
            :max="inputs.wariant2_rozszerzenia.max"
            v-model="inputData.wariant2_rozszerzenia.value"
            @change="changeInputs('wariant2_rozszerzenia')">
          </div>

          <div class="form-group">
            <md-avatar>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill iconInfo" viewBox="0 0 16 16" style="">
              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
              <md-tooltip md-direction="right" class="tooltipImg">
                <h4>{{$t('message.wariant3_title')}}</h4>
                <img src="../assets/wariant3.jpg"/>
                <p>{{$t('message.wariant3_title')}}</p>
              </md-tooltip>
            </md-avatar>
            <label for="wariant3" class="wariant-label">{{$t('message.wariant')}} 3</label>
            <input type="number" class="form-control form-control-sm wariant-input" id="wariant3"
            :min="inputs.wariant3.min"
            :max="inputs.wariant3.max"
            v-model="inputData.wariant3.value"
            @change="changeInputs('wariant3')">
            <span v-if="inputs.wariant3.value>0" class="wariant-span">{{$t('message.rozszerzenie')}}</span>
            <input v-if="inputs.wariant3.value>0"
            type="number" class="form-control form-control-sm wariant-rozszerzenia-input" id="wariant3_rozszerzenia"
            :min="inputs.wariant3_rozszerzenia.min"
            :max="inputs.wariant3_rozszerzenia.max"
            v-model="inputData.wariant3_rozszerzenia.value"
            @change="changeInputs('wariant3_rozszerzenia')">
          </div>

          <div class="form-group">
            <md-avatar>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill iconInfo" viewBox="0 0 16 16" style="">
              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
              <md-tooltip md-direction="right" class="tooltipImg">
                <h4>{{$t('message.wariant4_title')}}</h4>
                <img src="../assets/wariant4.jpg"/>
                <p>{{$t('message.wariant4_title')}}</p>
              </md-tooltip>
            </md-avatar>
            <label for="wariant4" class="wariant-label">{{$t('message.wariant')}} 4</label>
            <input type="number" class="form-control form-control-sm wariant-input" id="wariant4"
            :min="inputs.wariant4.min"
            :max="inputs.wariant4.max"
            v-model="inputData.wariant4.value"
            @change="changeInputs('wariant4')">
            <span v-if="inputs.wariant4.value>0" class="wariant-span">{{$t('message.rozszerzenie')}}</span>
            <input v-if="inputs.wariant4.value>0"
            type="number" class="form-control form-control-sm wariant-rozszerzenia-input" id="wariant4_rozszerzenia"
            :min="inputs.wariant4_rozszerzenia.min"
            :max="inputs.wariant4_rozszerzenia.max"
            v-model="inputData.wariant4_rozszerzenia.value"
            @change="changeInputs('wariant4_rozszerzenia')">
          </div>

          <!-- <div class="form-group">
            <label for="wariant5" class="wariant-label">wariant 5</label>
            <input type="number" class="form-control form-control-sm wariant-input" id="wariant5"
            :min="inputs.wariant5.min"
            :max="inputs.wariant5.max"
            v-model="inputData.wariant5.value"
            @change="changeInputs('wariant5')">
            <input v-if="inputData.wariant5.value>0"
            type="number" class="form-control form-control-sm" id="wariant5_rozszerzenia"
            :min="inputs.wariant5_rozszerzenia.min"
            :max="inputs.wariant5_rozszerzenia.max"
            v-model="inputData.wariant5_rozszerzenia.value"
            @change="changeInputs('wariant5_rozszerzenia')">
          </div> -->
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: 'Urzadzenia',
  mixins: [app, materials, calculation],
  data () {
    return {
      page: 'main',
      inputData: {
        wzmacniacz: { 'value': 0, 'min': 0, 'max': 9 },
        wzmacniacz_rezerwowy: { 'value': 0, 'min': 0, 'max': 9 },
        kontroler: { 'value': 0, 'min': 0, 'max': 1 },
        router: { 'value': 0, 'min': 0, 'max': 6 },
        wariant1: { 'value': 0, 'min': 0, 'max': 1 },
        wariant1_rozszerzenia: { 'value': 0, 'min': 0, 'max': 1 },
        wariant2: { 'value': 0, 'min': 0, 'max': 16 },
        wariant2_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
        wariant3: { 'value': 0, 'min': 0, 'max': 16 },
        wariant3_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
        wariant4: { 'value': 0, 'min': 0, 'max': 16 },
        wariant4_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
        // wariant5: { 'value': 0, 'min': 0, 'max': 16 },
        // wariant5_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },

        obudowa_plytki: { 'value': 0, 'min': 0, 'max': 1000 },
        panel_wentylacyjny: { 'value': 0, 'min': 0, 'max': 1 },
        kolka: { 'value': 0, 'min': 0, 'max': 1 }
      }
    }
  },
  computed: {
    ...mapGetters('app', ['selected_input']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy']),

    check_wentylator () {
      return (this.outputs.szafa.attributes.wysokosc > 24) ? 0 : 1
    }
  },
  watch: {
    inputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        Object.keys(this.inputData).forEach(element => {
          this.inputData[element]['value'] = newValue[element].value
        })
      }
    }
  },
  methods: {
    changePage (page) {
      this.page = page
    }
  }
}
</script>

<style scoped>
.iconInfo {
margin-right: 0px; color: #3ba3ff;cursor: pointer;width:16px;position: relative;top: 0px;
}
.iconInfo:hover {
  background: #3ba3ff; color: #fff; border: 1px solid #3ba3ff;
}
  .wariant-label {
    width:74px;
  }
  .wariant-input {
    /* position: relative;
    left: -48px;
    top: 4px;*/
    width:60px
  }
  .wariant-rozszerzenia-input {
    /* position: relative;
    right: 2px;
    top: 4px; */
    width: 60px;
  }
  .wariant-span {
    font-size: 13px;
    margin: 0px 12px;
  }

  #nav {
    border-bottom: 1px solid #999
  }
  #nav button#tab-home, #nav button#tab-pages {
    background: #fff;
    width: 135px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #999;
    top: 1px;
    position: relative;
    cursor: pointer;
  }
  #nav button#tab-home.active, #nav button#tab-pages.active {
    border-top: 1px solid #999;
    border-left: 1px solid #999;
    border-right: 1px solid #999;
    border-bottom: 1px solid #fff;
  }
  #tab-main, #tab-other {
    margin-top: 5px;
  }
  .md-avatar {
    width: 0px;
    min-width: 20px;
    height: 28px;
    border-radius: 0px;
    margin:2px 0px;
  }
  .tooltipImg  {
    margin-left:50px;
    padding:10px;
    width: 520px;
    height: 400px;
    font-size: 14px;
    background: white !important;
    border: 3px solid #215D8C !important;
  }
  .tooltipImg img {
    padding: 10px;
    font-size: 14px;
  }
  .tooltipImg h4 {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .tooltipImg p {
    color: #333;
    font-size: 16px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Urzadzenia.vue